import {Picker, PickerOptions, PickerResult} from '../model';

const maxLength = 200;
const validate = (files: File[]) => {
  const elementWithBigName = files.find((file) => file.name.length > maxLength);
  const isValidFiles = !elementWithBigName;
  return isValidFiles;
};

export class FilePickerController implements Picker {
  constructor(private readonly options: PickerOptions) {}

  pick(onStart: () => void, onEnd: (err: any, results: PickerResult[]) => void): void {
    const {options} = this;
    const input = document.createElement('input');
    document.body.append(input);
    input.type = 'file';
    input.multiple = !!options.multiple;
    if (options.accept?.web) {
      const accept = options.accept.web;
      input.accept = Array.isArray(accept) ? accept.join(',') : accept;
    }

    const changeHandler = (event: Event) => {
      onStart();

      const list = (event.target as HTMLInputElement).files;
      if (list) {
        const arrayFile = Array.from(list);
        const isValid = validate(arrayFile);
        if (!isValid) {
          onEnd({message: `Имя файла превышает ${maxLength} символов`}, []);
          return;
        }
        onEnd(
          null,
          arrayFile.map((f) => ({file: f, platform: 'web'})),
        );
      }
      input.remove();
    };

    input.addEventListener('change', changeHandler);
    input.click();
  }
}
